import createStore from './Store';
import reducer from './Reducers'
import { version } from '../config';
import { getDefaultTranslations } from '../services/language/languages';

export { store as AttributesStore, initializeStore };

function isIos() {
  return /iPad|iPhone|iPod/.test(window.navigator.userAgent);
}

/** higher number means upper, actions have 1 by default */
const defaultItemsOrder = {
  chat: 5,
  call: 3,
  mail: 2,
  video: 4
};

const defaultState = {
  badges: 0,
  canUseAPI: true,
  channelsOpen: false,
  defaultOrder: defaultItemsOrder,
  flashcard: false,
  hideAllBtn: false,
  isIos: isIos(),
  isFrameOpened: false,
  isLoaderHidden: false,
  items: [],
  language: 'pl',
  loaderVersion: version,
  mediaMobileWidth: undefined,
  messages: getDefaultTranslations('pl'),  //actual messages used in GUI
  order: {},
  styleTemplate: 'normal',
  widgetVersion: 'uninitialized',
  title: 'uninitialized',
  translations: {}  //translation overrides
};

let store = {
  dispatch: notInitialized,
  subscribe: notInitialized,
  getState: notInitialized,
  get: notInitialized
};

function notInitialized() {
  throw new Error('store was not initialized');
}

function initializeStore() {
  return store = createStore(reducer, defaultState, wasChangedEnhancer);
}

// const store = wasChangedEnhancer(createStore)(reducer, defaultState);

function wasChangedEnhancer(createStore) {
  return function (reducer, defaultState) {
    const store = createStore(reducer, defaultState);
    const _dispatch = store.dispatch;
    const calledActions = {};

    store.dispatch = function (action) {
      if (calledActions[action.type]) {
        const oldAction = calledActions[action.type];

        const wasCalled = Object.keys(action).every(function (key) {
          return oldAction[key] === action[key];
        });

        if (wasCalled) {
          return;
        }
      }

      calledActions[action.type] = action;
      return _dispatch.call(null, action);
    };

    return store;
  }
}
